<div class="container-xxl" (window:resize)="onResize()">
    <div class="row">
        <div class="col-12">
            <div>
                <div class="discover-title">
                  <div class="subtitle">Investment Products</div>
                    <h1 *ngIf="!isNvmf" class="title">Vanguard {{subtitle}}</h1>
                      <p *ngIf="subtitle==='529 plan portfolios'" class="discover-title__description" [innerHTML]="formatLink(educational529Link.contentValue)"></p>
                    <h1 *ngIf="isNvmf && !isMobileResolution" class="title" style="white-space: nowrap;">{{fundFamilySelection}}</h1>
                    <h1 *ngIf="isNvmf && isMobileResolution" class="title">{{fundFamilySelection}}</h1>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div [ngClass]="openFilterView ?'col-lg-3 col-md-4 col-sm-12':'display-none'" *ngIf="detailViewSwitch && openFilterView ">
            <div class="cell1">
                <div  *ngIf="!isMobileResolution">
                  <div class="filter-button-container" *ngIf="!isMobileResolution && detailViewSwitch && openFilterView && !isNvmf">
                    <c11n-button class="col" [buttonType]="'button'" [size]="'small'" [iconName]="'link-left'" [labelText]="filtersLabel" (clickEvent)="openFilters()" variant="secondary"></c11n-button>
                    <div class="vg-paragraph-two col results-count" [cdkAriaLive]="'polite'" aria-live="polite" aria-atomic="true">
                      <span class="num-totresults-vg" *ngIf="!areAllFiltersEmpty()" [innerHtml]="filteredCount()"></span>
                      <span class="num-results-vg" *ngIf="areAllFiltersEmpty()" [innerHtml]="filteredCountDetailView()"></span>
                    </div>
                  </div>

                  <div class="filter-button-container" *ngIf="!isMobileResolution && detailViewSwitch && openFilterView  && isNvmf">
                    <c11n-button class="col" [buttonType]="'button'" [size]="'small'" [iconName]="'link-left'" [labelText]="filtersLabel" (clickEvent)="openFilters()" variant="secondary"></c11n-button>
                    <div class="vg-paragraph-two col" [cdkAriaLive]="'polite'" aria-live="polite" aria-atomic="true">
                      <span class="num-totresults-vg" *ngIf="!areAllFiltersEmpty()" [innerHtml]="filteredCount()"></span>
                      <span class="num-results-vg" *ngIf="areAllFiltersEmpty()" [innerHtml]="filteredCountDetailView()"></span>
                    </div>
                  </div>
                </div>
                <div *ngIf="showFilters">
                    <VFA-filters  [showFilters]="showFilters" [initialPageLoad]="initialPageLoad" [accountingTypeOptions]="accountingTypeOptions" [productType]="productType"  *ngIf="!isMobileResolution && openFilterView" ></VFA-filters>
                </div>
                <div *ngIf="isMobileResolution;">
                    <div class="mobile-filter-btn float-end filters-mobile-bottom">
                        <div>
                            <c11n-button [buttonType]="'button'" [size]="'medium'" [iconName]="'filter'"
                            [labelText]="'Filters (' + numAppliedFilters + ')'" (clickEvent)="mobileFiltersModalDialog.openModalDialog()" variant="secondary"></c11n-button>
                        </div>
                    </div>
                </div>
                <div *ngIf="isMobileResolution;">
                    <span class="vg-paragraph-two number-of-results-mobile" [innerHtml]="filteredCount()"></span>
              </div>
            </div>
        </div>

        <div class="col-lg-3 col-md-4 col-sm-12" *ngIf="isMobileResolution">
            <filter-by [isMobileResolution]="isMobileResolution"></filter-by></div>
        <div class="filters-mobile" [ngClass] ="(detailViewSwitch  && !openFilterView) ? 'col':'col-lg-9 col-md-8 col-sm-12 p-0'">
            <div *ngIf="!isMobileResolution; else mobileResults">
                <VFA-results  [isNonVanguard]="isNvmf" (detailedViewValue)="setdetailedViewValue($event)"
                 [closeFilters]="closeFilters" [numOfResults]="numOfResults" [numAppliedFilters]="numAppliedFilters" [NVGnumTotalResults]="NVGnumTotalResults"
                 [numTotalResults]="numTotalResults" [isNvmf]="isNvmf" (openFilterValue)="setopenFilterValue($event)"
                 [areAllFiltersEmpty]="areAllFiltersEmpty()">
                </VFA-results>
            </div>
            <ng-template #mobileResults>
                <VFA-results-mobile  [isNonVanguard]="isNvmf" [viewSwitch]="viewSwitch"></VFA-results-mobile>
            </ng-template>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <div>
                <div class="legal-disclaimers">
                    <p class="rps-paragraph-one rps-grey" [innerHtml]="subjectToRisk?.contentValue" attr.data-aem-source="{{subjectToRisk?.isAEM | json}}"></p>
                    <p class="rps-paragraph-one rps-grey" [innerHtml]="pastPerformance?.contentValue" attr.data-aem-source="{{pastPerformance?.isAEM | json}}"></p>
                    <p class="rps-paragraph-one rps-grey" [innerHtml]="performanceDataForPeriods?.contentValue" attr.data-aem-source="{{performanceDataForPeriods?.isAEM | json}}"></p>
                    <p class="rps-paragraph-one rps-grey rps-mark-bold no-margin">Vanguard Funds and ETFs</p>
                    <p class="rps-paragraph-one rps-grey" [innerHtml]="forMoreInformation?.contentValue" attr.data-aem-source="{{forMoreInformation?.isAEM | json}}"></p>
                    <p class="rps-paragraph-one rps-grey" [innerHtml]="municipalMoneyMarket?.contentValue" attr.data-aem-source="{{municipalMoneyMarket?.isAEM | json}}"></p>
                    <p class="rps-paragraph-one rps-grey" [innerHtml]="vanguardCashReserves?.contentValue" attr.data-aem-source="{{vanguardCashReserves?.isAEM | json}}"></p>
                    <p class="rps-paragraph-one rps-grey link-styling" [innerHtml]="vanguardBrokerageServices?.contentValue" attr.data-aem-source="{{vanguardBrokerageServices?.isAEM | json}}"></p>
                    <p class="rps-paragraph-one rps-grey rps-mark-bold no-margin">Vanguard 529s plan portfolios</p>
                    <p class="rps-paragraph-one rps-grey link-styling" [innerHtml]="formatLink(collegeSavingsPlan?.contentValue)" attr.data-aem-source="{{collegeSavingsPlan?.isAEM | json}}">
                    <p class="rps-paragraph-one rps-grey" [innerHtml]="beforeInvestingIn529?.contentValue" attr.data-aem-source="{{beforeInvestingIn529?.isAEM | json}}"></p>
                    <p class="rps-paragraph-one rps-grey" [innerHtml]="vanguardInvestmentManager?.contentValue" attr.data-aem-source="{{vanguardInvestmentManager?.isAEM | json}}"></p>
                    <p class="rps-paragraph-one rps-grey rps-mark-bold no-margin">Non-Vanguard mutual funds</p>
                    <p class="rps-paragraph-one rps-grey" [innerHtml]="nonVanguardSECYield?.contentValue" attr.data-aem-source="{{nonVanguardSECYield?.isAEM | json}}"></p>
                    <p class="rps-paragraph-one rps-grey link-styling relink-styling" [innerHtml]="noTransactionFee?.contentValue" attr.data-aem-source="{{noTransactionFee?.isAEM | json}}"></p>
                    <p class="rps-paragraph-one rps-grey" [innerHtml]="allTransactionsSubj?.contentValue" attr.data-aem-source="{{allTransactionsSubj?.isAEM | json}}"></p>
                    <p class="rps-paragraph-one rps-grey" [innerHtml]="nonVanguardThirdParty?.contentValue" attr.data-aem-source="{{nonVanguardThirdParty?.isAEM | json}}"></p>
                    <p class="rps-paragraph-one rps-grey" [innerHtml]="nonVanguardMFFees?.contentValue" attr.data-aem-source="{{nonVanguardMFFees?.isAEM | json}}"></p>

                </div>
            </div>
        </div>
    </div>
    <c11n-modal-dialog modalId="mobileFiltersModal" variant="basic" headingText="" #mobileFiltersModalDialog>
        <div c11n-modal-dialog-body>
            <div class="filter-layer-container">
                <h5>{{ filtersLabel }}</h5>
                <p class="number-of-results-dialog" [innerHtml]="filteredCount()">
                </p>
                <div *ngIf="showFilters && isMobileResolution">
                    <VFA-filters [showFilters]="showFilters" [initialPageLoad]="initialPageLoad" [accountingTypeOptions]="accountingTypeOptions" [productType]="productType" ></VFA-filters>
                </div>

            </div>
            <div class="bottom-btns-container">
                <c11n-button [buttonType]="'button'" [size]="'medium'" [variant]="'secondary'" [labelText]="'Clear Filters'"
                    [colorMode]="'on-light'" (clickEvent)="clearFilters()"></c11n-button>
                <c11n-button [buttonType]="'button'" [size]="'medium'" [variant]="'primary'" [labelText]="'See '+numOfResults"
                    [colorMode]="'on-light'" (clickEvent)="mobileFiltersModalDialog.closeDialogModal()"></c11n-button>
            </div>
        </div>

    </c11n-modal-dialog>

    <VFA-compare-tool-banner *ngIf="filtersService.compareFundCount>0" (clearSelectedCheckbox)="clearCheckbox()"></VFA-compare-tool-banner>

</div>
